import { AllContainerLogBookResponseModel, ContainerLoadingReportResponseModel, ContainerLogBookResponseModel, FileUploadResponse } from "@gtpl/shared-models/logistics";
import { ApplicationExceptionHandler } from "@gtpl/shared-utils/error-messages";
import { Body, Controller, Post, UploadedFile, UseInterceptors } from "@nestjs/common";
import { FileInterceptor } from "@nestjs/platform-express";
import { ApiConsumes, ApiTags } from "@nestjs/swagger";
import { extname } from "path";
import { ContainerLogBookService } from "./container-log-book.service";
import { ContainerLoadingFileUploadDto } from "./dto/container-loading-file-upload-dto";
import { ContainerLogBookDto } from "./dto/container-log-book.dto";
import { diskStorage } from 'multer';
import { SaleOrderIdRequest } from "@gtpl/shared-models/procurement-management";
import { CommonResponse } from "@gtpl/shared-models/masters";
import { PlantIdRequest } from "@gtpl/shared-models/warehouse-management";
@ApiTags('container Log Book')
@Controller('container-log-book')
export class ContainerLogBookController {
    constructor(private service: ContainerLogBookService, private readonly applicationExceptionHandler: ApplicationExceptionHandler) { }

    @Post('/containerLoadingFileUpload')
    @ApiConsumes('multipart/form-data')
    @UseInterceptors(FileInterceptor('file', {
        limits: { files: 1 },
        storage: diskStorage({
        destination: './upload-files/container-loading-upload-files',
        filename: (req, file, callback) => {
            const name = file.originalname.split('.')[0];
            const fileExtName = extname(file.originalname);
            const randomName = Array(4)
            .fill(null)
            .map(() => Math.round(Math.random() * 16).toString(16))
            .join('');
            callback(null, `${name}-${randomName}${fileExtName}`);
        },
        }),
        fileFilter: (req, file, callback) => {
        if (!file.originalname.match(/\.(zip)$/)) {
            return callback(new Error('Only zip files are allowed!'), false);
        }
        callback(null, true);
        },
    }))
    async containerLoadingFileUpload(@UploadedFile() file, @Body() uploadData: ContainerLoadingFileUploadDto): Promise<FileUploadResponse> {
        try {
            return await this.service.updatePath(file.path, uploadData.containerLogBookId);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(FileUploadResponse, error);
        }
    }
    @Post('/getCreateContainerLogBook')
    async getCreateContainerLogBook(@Body() req:ContainerLogBookDto,isUpdate:boolean=false): Promise<ContainerLogBookResponseModel> {
        try {
            console.log(req);
            return await this.service.getCreateContainerLogBook(req, false);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(ContainerLogBookResponseModel, error)
        }
    }
    @Post('/getUpdateContainerLogBook')
    async getUpdateContainerLogBook(@Body() req:ContainerLogBookDto,isUpdate:boolean=true): Promise<ContainerLogBookResponseModel> {
        try {
            console.log(req);
            return await this.service.getCreateContainerLogBook(req, true);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(ContainerLogBookResponseModel, error)
        }
    }
    @Post('/getContainerLogDetails')
    async getContainerLogDetails(): Promise<AllContainerLogBookResponseModel> {
        try {
            return await this.service.getContainerLogDetails();
        } catch (error) {
            return this.applicationExceptionHandler.returnException(AllContainerLogBookResponseModel, error)
        }
    }
    @Post('/getContainerLoadingReport')
    async getContainerLoadingReport(@Body() req: SaleOrderIdRequest): Promise<ContainerLoadingReportResponseModel> {
        try {
            return await this.service.getContainerLoadingReport(req);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(ContainerLoadingReportResponseModel, error)
        }
    }

    @Post('/getSaleOrderDropdown')
    async getSaleOrderDropdown(@Body() req: PlantIdRequest): Promise<CommonResponse> {
        try {
            return await this.service.getSaleOrderDropdown(req);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error)
        }
    }

}
